// @ts-check

/**
 * @module network/kpi
 */

import { post } from './fetch';

/**
 * Fires a POST to register a kpi
 * @param {object} options
 * @param {string} options.url - the url of the kpi service
 * @param {string} options.section - the kpi section
 * @param {string} options.measurement - the kpi measurement
 * @param {string} options.context - the kpi context
 */
export function postKpi({
    url = '/restapi/common/kpi/v1',
    section,
    measurement,
    context = null,
}) {
    return post(url, {
        measureSection: section,
        measurement: measurement,
        measureContext: context
    });
}
